module.exports = __webpack_public_path__ + "img/ud_predictive_analytics.90ebfe42.svg";